module.exports = __webpack_public_path__ + "static/Anbaugebiet-Rheinhessen-800x785-d2ff63011d7792d3fa0339e374f5e284.jpeg";